import loadable from '@loadable/component';

/* istanbul ignore next */
// eslint-disable-next-line import/prefer-default-export
export const SavedItemsList = loadable(() =>
    import(
        /* webpackChunkName: "SavedItemsLazy" */ '../../../../components/SavedItemsList/SavedItemsList'
    )
);
